/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "3b0ceb732199c792befff9a9b064f111fb4a1339";
